import React, { useState, useEffect, useRef } from 'react';
import { FileText, Github, Linkedin, Monitor } from 'lucide-react';

const icons = {
  Resume: <FileText />,
  LinkedIn: <Linkedin />,
  Github: <Github />,
  Portfolio: <Monitor />,
};

const LinksSection = () => {
  const links = [
    { label: 'Portfolio', url: '/work', icon: icons.Portfolio },
    { label: 'Resume', url: '/resume', icon: icons.Resume },
    { label: 'LinkedIn', url: 'https://www.linkedin.com/in/andrewsnyderdesign', icon: icons.LinkedIn },
    { label: 'Github', url: 'https://github.com/AndrewAlllDay', icon: icons.Github },

  ];

  const [isMobile, setIsMobile] = useState(false);
  const [hasAnimated, setHasAnimated] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkIsMobile();
    window.addEventListener('resize', checkIsMobile);

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !hasAnimated) {
            setHasAnimated(true);
          }
        });
      },
      {
        root: null,
        rootMargin: '0px',
        threshold: 0.2,
      }
    );

    const currentSection = sectionRef.current;
    if (currentSection) {
      observer.observe(currentSection);
    }

    return () => {
      window.removeEventListener('resize', checkIsMobile);
      if (currentSection) {
        observer.unobserve(currentSection);
      }
    };
  }, [hasAnimated]);

  return (
    <div
      ref={sectionRef}
      className='w-[75%] h-screen md:h-[60vh] bg-white flex items-center justify-center mx-auto p-0 md:p-8 pt-28'
    >
      <div className='max-w-5xl w-full grid grid-cols-1 md:grid-cols-3 md:gap-10 bg-white rounded-lg md:p-10 p-2'>
        <div className='flex flex-col justify-center col-span-2 text-center md:text-left'>
          <div>
            <h2 className={`text-4xl font-bold border-b-4 border-cyan-500 inline-block text-gray-800 mb-5`}>
              Explore My Work
            </h2>
          </div>
          <p className={`text-gray-600 text-lg md:text-md`}>
            Want to dive deeper into my professional experience? Here's a collection of links where you can explore my resume, view my projects on GitHub, and connect with me on LinkedIn.
          </p>
        </div>

        <div className='grid grid-cols-2 gap-y-8 md:flex md:flex-col md:space-y-4 md:items-start justify-center items-center md:mt-0 mt-10'>
          {links.map((link, index) => (
            <a
              key={index}
              href={link.url}
              target={link.label !== 'Portfolio' ? '_blank' : ''}
              rel={link.label !== 'Portfolio' ? 'noopener noreferrer' : ''}
              className={`
                flex flex-col items-center justify-center text-blue-600 font-medium text-lg
                group hover:text-blue-700
                transition-all duration-500
                transform hover:translate-x-1 will-change-transform translate-z-0
                ${hasAnimated
                  ? `animate-fade-in-up delay-${index * 200}`
                  : 'opacity-0 translate-y-2'
                }
              `}
            >
              {isMobile ? (
                <>
                  <span className="text-4xl text-gray-700">{link.icon}</span>
                  <p className="mt-1 text-base text-gray-500">{link.label}</p>
                </>
              ) : (
                <div className='flex items-center w-full justify-between'>
                  <div className="flex items-center">
                    <span className='inline-flex items-center justify-center mr-8 text-gray-600 w-5 h-5 align-middle transform flex-shrink-0'>
                      {link.icon}
                    </span>
                    {link.label}
                  </div>
                  <span className='inline-flex items-center ml-3 text-blue-600 text-2xl align-middle'>
                    →
                  </span>
                </div>
              )}
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LinksSection;